import { Dictionary } from '@reduxjs/toolkit';
import { JsonifiedFile } from '../utility/functions';
import { DiscardableModel } from './DiscardableModel';
import { ErroredModel } from './ErroredModel';
import { Field } from './FieldCommon';
import { PaginationMeta } from './pagination';
import { TaggableModel } from './Tag';

export enum EmployeeNotificationKey {
  NOTE_MENTION = 'note_mention',
  TASK_ASSIGNED = 'task_assigned',
}

export type Employee = ErroredModel &
  DiscardableModel &
  TaggableModel & {
    uuid: string;
    chosen_name?: string;
    display_name: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    user_id: number;
    user_roles_uuids?: string[];
    invited?: boolean;
    avatar_url?: string;
    avatar?: JsonifiedFile;
    roles_uuids: string[];
    roles_values: string[];
    title_value: string;
    title_uuid: string;
    code: string;
    extension?: string;
    user_notifications?: Dictionary<string>;
    notifications?: Record<string, boolean>;
    fields: Field[];
  };

export type EmployeeResponse = {
  data: Employee[];
  meta: PaginationMeta;
};

export type EmployeeRestricted = {
  uuid: string;
  display_name: string;
  email: string;
};
